import type { Lang } from '../i18n/types';
import type { SeoMeta } from './keywords';

export type PageSeoId = 'home' | 'unite-base' | 'unite-go' | 'blog-list';

type PageSeoMap = Record<PageSeoId, Record<Lang, SeoMeta>>;

let cache: PageSeoMap | null = null;
let loading: Promise<PageSeoMap | null> | null = null;

export async function fetchPageSeoMap(): Promise<PageSeoMap | null> {
  if (cache) return cache;
  if (loading) return loading;

  loading = (async () => {
    try {
      const res = await fetch('/api/seo', { headers: { Accept: 'application/json' } });
      if (!res.ok) return null;
      const data = (await res.json()) as { ok: boolean; pages: PageSeoMap };
      cache = data.pages;
      return cache;
    } catch {
      return null;
    } finally {
      loading = null;
    }
  })();

  return loading;
}

export function getPageSeoMeta(page: PageSeoId, lang: Lang): SeoMeta | null {
  return cache?.[page]?.[lang] ?? null;
}

export function invalidatePageSeoCache(): void {
  cache = null;
  loading = null;
}

export function routeToPageSeoId(page: string): PageSeoId | null {
  if (page === 'home' || page === 'unite-base' || page === 'unite-go' || page === 'blog-list') {
    return page;
  }
  return null;
}
